function FbaMintPass(address, factory) {
    this.contract = new window.dazeth.web3.eth.Contract(window.dazContracts["ISafeBatchTransferFrom"], address);
    this.factory = factory;
    this.enabled = false;
    this.maxPerTransaction = 1;
    this.initialized = false;
}

FbaMintPass.prototype.init = async function () {
    /*try {
        this.enabled = await this.contract.methods.publicMintEnabled().call();
    } catch (e) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "init",
                data: {},
                error: e
            }
        }));
        throw e;
    }*/
    this.enabled = true;
    this.initialized = true;
    return {
        enabled: this.enabled,
        initialized: this.initialized,
        maxPerTransaction: this.maxPerTransaction,
    }
}

FbaMintPass.prototype.data = function (passToken, prop, traits, hash, sig) {
    console.log([prop, traits, hash, sig]);
    return {
        from: dazethutil.me(),
        passToken: passToken.toString(),
        qty: '1', // can only do 1 at a time
        data: dazeth.web3.eth.abi.encodeParameters(['uint256', 'uint256[10]', 'bytes32', 'bytes'], [prop ? prop : 9999999, traits, hash, sig])
    }
}

FbaMintPass.prototype.checkEnabled = function () {
    if (!this.enabled || !this.initialized) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "pre_mint",
                data: {
                    enabled: this.enabled,
                    initialized: this.initialized
                },
                error: "not enabled"
            }
        }));
        throw "not enabled";
    }
}

FbaMintPass.prototype.mint = async function (data) {
    this.checkEnabled();
    return data;
}

FbaMintPass.prototype.complete = async function (data, mint) {
    console.log(data, mint);
    return await this.contract.methods.safeTransferFrom(data.from, this.factory, data.passToken, data.qty, data.data).send({
        from: data.from,
        value: 0,
    }).on('transactionHash', (hash) => mint.onTransactionHash(data, hash)).catch((err) => {
        throw err;
    });
}
